<div class="content-page text-center">
    <div class="form-reset">
        <div class="text-info">
            <h3>{{ 'firstLoginPasswordChange.appTitle' | translate }}</h3>
        </div>
        <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="message !== ''">
            {{message}}
        </ngb-alert>
        <div class="form-reset-content">
            <div class="card">
                <h5 class="card-header">{{ 'firstLoginPasswordChange.title' | translate }}</h5>
                <div class="card-body">
                    <form [formGroup]="form" (ngSubmit)="onSubmit()">
                        <div class="form-floating mb-2">
                            <input formControlName="password" type="{{showPassword? 'text': 'password'}}"
                                class="form-control" id="password" placeholder="name@example.com" />
                            <label for="password">{{ 'firstLoginPasswordChange.form.passwordLabel' | translate }}</label>
                        </div>
                        <app-password-strength [passwordToCheck]="form.value.password"
                            (passwordStrength)="onPasswordStrengthChanged($event)"></app-password-strength>
                        <div *ngIf="loading" class="spinner-border text-info mt-5" role="status">
                            <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
                        </div>
                        <div class="form-check d-flex align-items-center my-4">
                            <input class="form-check-input " (click)="togglePassword()" type="checkbox" value="showPassword"
                                id="flexCheckDefault">
                            <label class="form-check-label ms-2" for="flexCheckDefault">
                                {{ 'firstLoginPasswordChange.form.showPassword' | translate }}
                            </label>
                        </div>
                        <button [disabled]="!form.valid || loading" *ngIf="!loading"
                            class="mt-3 w-100 btn btn-lg btn-primary text-white" type="submit">
                            {{ 'firstLoginPasswordChange.form.submitButton' | translate }}
                        </button>
                    </form>
                </div>
            </div>
            <p class="mt-5 mb-3 text-muted">{{ 'firstLoginPasswordChange.footer.copyright' | translate }}</p>
        </div>
    </div>
</div>